import { Component, effect, OnInit } from '@angular/core';
import { Session } from './shared/models/session.model';
import { Plan } from './shared/models/plan.model';

import { RouterModule, RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { PlanService } from './shared/plan-data.service';
import { DirectSessionLogicService } from './shared/direct-session-logic.service';
import { PromoService } from './shared/promo.service';
import { NgClass, NgIf } from '@angular/common';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AgilityContentService } from './shared/agility-content-model.service';
import { AgilityContentModel } from './shared/models/agility-content.model';
import { ConfigData } from './shared/models/config-data.model';
import { firstValueFrom } from 'rxjs';

import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  template: `
  <div class="top-level">
    <direct-header *ngIf="!isInIframe" style="width:100%" ></direct-header>

    <div class="main-container">
      <router-outlet></router-outlet>
    </div>

    <div class=""
    [ngClass]="(isMobile && PlanSelected.name != undefined)? 'bottom-container' : '' "
    >
      <direct-random-facts *ngIf="!isInIframe && !isMobile && showTips" class="facts-container text-center tip-normal-spacing"></direct-random-facts>
      <accessibility-text></accessibility-text>
      <faq-text></faq-text>
      <terms-text></terms-text>
      <privacy-text></privacy-text>
      <bs-error-component></bs-error-component>
      <page-term-details></page-term-details>
      <direct-footer *ngIf="!isInIframe"></direct-footer>
    </div>

    <div *ngIf="isMobile && PlanSelected.name != undefined " >
      <div *ngIf="!confirmationPage" >
        <app-form-navigation-controls class="mobile-nav"></app-form-navigation-controls>
      </div>
    </div>

  </div>

  `,
  styleUrls: ['./app.component.scss'],
  providers: [
    PlanService, 
    DirectSessionLogicService, 
    RouterModule, 
    RouterOutlet,
    NgClass,
    NgIf,

  ]

})
export class AppComponent implements OnInit {
  title = 'app-modular-direct-site';

  Session!: Session;
  Plans: Plan[] = [] ;
  config!: ConfigData;

  contentModel!: AgilityContentModel;

  windowWidth!: number;
  isMobile: boolean = false;
  showTips: boolean = false;
  confirmationPage: boolean = false;
  readonly isInIframe: boolean = (() => { try { return window.self !== window.top; } catch { return true; } })();

  singleRestestOnAgilityFail: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public directSessionLogic: DirectSessionLogicService,
    public promoService: PromoService,
    public responsive: BreakpointObserver,
    public agilityService: AgilityContentService
  ) {  
    effect(() => {
      //get trimmed session details here
      let specialDetails = {};
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        // Show tips through the signup flow, but drop off at checkout (they're already sold)
        this.showTips = url.startsWith('/signup') && !url.startsWith('/signup/checkout');
      }
    });

    // effect(() => {
    //   let agilityObjects = this.directSessionLogic.agilityObjectsSignal();
    //   if(agilityObjects != null) this.getContentModel();
    // });
  }

  get PlanSelected(): Plan {
    return this.directSessionLogic.planSelectedSignal();
  }

  async ngOnInit(): Promise<void> {

    //this.directSessionLogic.setSessionIp();

    this.responsive.observe([
      Breakpoints.XSmall, Breakpoints.Small
      ])
      .subscribe(result => {
        this.isMobile = false; 
        if (result.matches) 
          this.isMobile = true;      
    });

    this.config = environment as ConfigData;
    this.setFavIcon(this.config.CompanyInfo.AgilityFavIcon);

    // this.directSessionLogic.session$.subscribe( session => {
    //   if(session.purchaseRef != undefined){
    //     if(session.purchaseRef.length > 0){
    //       this.confirmationPage = true;
    //     } 
    //   }
    // });
  }

  setFavIcon(faviconUrl: string ) {
    const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  async getContentModel(){
    try{
      this.directSessionLogic.initAgilityObjectsSignal();
    }
    catch(error){
      if(!this.singleRestestOnAgilityFail){
        this.singleRestestOnAgilityFail = true;
        console.error("Error fetching AgilityModel app First: ", error);     
      }
      console.error("Error fetching AgilityModel app: ", error);
    };
  }

  reloadToRoot() {
    this.router.navigate(['/signup']);
  }
  
 }
